import http from "../util/http-common";
import {authHeader} from "../util/auth-header";

export class AuthService {

  static async getUserDetails(){
    return http.get("/cfadminsecurity/api/v1/auth/loggedin",{ headers: await authHeader()});
  }
}

export default AuthService;
